import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postFroder = (params) => {
  return axiosClient
    .post(`api/admin/stats/gamer-frod`, params)
    .then((r) => r.data);
};
